/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { contactPointTypeIdGet } from '../fn/contact-point-type/contact-point-type-id-get';
import { ContactPointTypeIdGet$Params } from '../fn/contact-point-type/contact-point-type-id-get';
import { ContactPointTypeModel } from '../models/contact-point-type-model';
import { ContactPointTypeModelSearchResultModel } from '../models/contact-point-type-model-search-result-model';
import { contactPointTypePost } from '../fn/contact-point-type/contact-point-type-post';
import { ContactPointTypePost$Params } from '../fn/contact-point-type/contact-point-type-post';
import { contactPointTypeSearchContactPointTypePost } from '../fn/contact-point-type/contact-point-type-search-contact-point-type-post';
import { ContactPointTypeSearchContactPointTypePost$Params } from '../fn/contact-point-type/contact-point-type-search-contact-point-type-post';

@Injectable({ providedIn: 'root' })
export class MDIContactPointTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactPointTypeSearchContactPointTypePost()` */
  static readonly ContactPointTypeSearchContactPointTypePostPath = '/ContactPointType/SearchContactPointType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPointTypeSearchContactPointTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  contactPointTypeSearchContactPointTypePost$Response(params?: ContactPointTypeSearchContactPointTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ContactPointTypeModelSearchResultModel>> {
    return contactPointTypeSearchContactPointTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPointTypeSearchContactPointTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  contactPointTypeSearchContactPointTypePost(params?: ContactPointTypeSearchContactPointTypePost$Params, context?: HttpContext): Observable<ContactPointTypeModelSearchResultModel> {
    return this.contactPointTypeSearchContactPointTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ContactPointTypeModelSearchResultModel>): ContactPointTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `contactPointTypeIdGet()` */
  static readonly ContactPointTypeIdGetPath = '/ContactPointType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPointTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPointTypeIdGet$Response(params: ContactPointTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ContactPointTypeModel>> {
    return contactPointTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPointTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPointTypeIdGet(params: ContactPointTypeIdGet$Params, context?: HttpContext): Observable<ContactPointTypeModel> {
    return this.contactPointTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ContactPointTypeModel>): ContactPointTypeModel => r.body)
    );
  }

  /** Path part for operation `contactPointTypePost()` */
  static readonly ContactPointTypePostPath = '/ContactPointType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPointTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  contactPointTypePost$Response(params?: ContactPointTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return contactPointTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPointTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  contactPointTypePost(params?: ContactPointTypePost$Params, context?: HttpContext): Observable<string> {
    return this.contactPointTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
